import * as types from "./actionTypes";
import { initialSingleVesselStore } from "./initialStore";

export function singleVesselReducer(state = initialSingleVesselStore, action) {
  switch (action.type) {
    case types.SET_CALCULATOR_DATA: {
      const payload = typeof action.payload === "function"
        ? action.payload(state.calculatorData)
        : action.payload;

      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          ...payload,
        },
      };
    }

    case types.SET_PORT_OPERATIONS: {
      const ops = typeof action.payload === "function"
        ? action.payload(state.calculatorData.portOperation)
        : action.payload;

      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          portOperation: ops,
        },
      };
    }

    case types.SET_FLEET_LIST: {
      const fleets = typeof action.payload === "function"
        ? action.payload(state.calculatorData.fleetList)
        : action.payload;

      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          fleetList: fleets,
        },
      };
    }

    case types.SET_SELECTED_QUERY: {
      const query = typeof action.payload === "function"
        ? action.payload(state.calculatorData.clientQuery)
        : action.payload;

      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          clientQuery: query,
        },
      };
    }

    case types.SET_SELECTED_VESSEL: {
      const vessel = typeof action.payload === "function"
        ? action.payload(state.selectedVessels)
        : action.payload;

      return {
        ...state,
        selectedVessels: vessel,
      };
    }

    case types.SET_SYNC_BUNKER:
      return {
        ...state,
        syncBunker: action.payload,
      };

    case types.SET_IS_OVERRIDE:
      return {
        ...state,
        isOverride: action.payload,
      };

    case types.SET_ESTIMATION_EST_ID:
      return {
        ...state,
        estimationEstId: action.payload,
      };

    case types.SET_SPLIT_HIRE_ARRAY: {
      const splitHire = typeof action.payload === "function"
        ? action.payload(state.splitHireArray)
        : action.payload;

      return {
        ...state,
        splitHireArray: splitHire,
      };
    }

    case types.SET_PORT_DISTANCE_RESPONSE:
      return {
        ...state,
        portDistanceResponse: action.payload.data || state.portDistanceResponse,
        realPortDistanceResponse: action.payload.realData || state.realPortDistanceResponse,
        portDistancePayloadResponse: action.payload.payload || state.portDistancePayloadResponse,
      };

    case types.RESET_CALCULATOR_STORE:
      return { ...initialSingleVesselStore };

    default:
      return state;
  }
}
